import { render, staticRenderFns } from "./DriverInsurance.vue?vue&type=template&id=ed38de9c&"
import script from "./DriverInsurance.vue?vue&type=script&lang=js&"
export * from "./DriverInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports